import { NavaidDTOCalculation, NavaidModel } from "./navaid";
import { ScreeningAngle } from "./screening-angle";
import { Sectorization } from "./sectorization";

export class RemoveGroundStationsDTO{
    navaids: NavaidDTOCalculation[];
    projectId: number;

    constructor(navaids: NavaidDTOCalculation[], projectId: number) {
        this.navaids = navaids;
        this.projectId = projectId;
    }
}

export function isToRemoveFromDLL(oldNavaid: NavaidModel, newNavaid: NavaidModel): boolean {
    if (
        oldNavaid.doc == null || oldNavaid.maxaltitude == null || oldNavaid.elevation == null ||
        newNavaid.doc == null || newNavaid.maxaltitude == null || newNavaid.elevation == null
    ) {
        return false;
    }

    if (
        oldNavaid.latitude != newNavaid.latitude ||
        oldNavaid.longitude != newNavaid.longitude ||
        oldNavaid.navaidid != newNavaid.navaidid ||
        oldNavaid.navaidtype != newNavaid.navaidtype ||
        oldNavaid.icaocc != newNavaid.icaocc ||
        oldNavaid.elevation != newNavaid.elevation ||
        oldNavaid.antheight != newNavaid.antheight ||
        oldNavaid.doc != newNavaid.doc ||
        oldNavaid.maxaltitude != newNavaid.maxaltitude ||
        oldNavaid.losthreshold != newNavaid.losthreshold ||
        !equalsMinScreenAngles(oldNavaid, newNavaid) ||
        !equalsSectorizations(oldNavaid, newNavaid) ||
        oldNavaid.usesectorization != newNavaid.usesectorization
    ) {
        return true;
    }

    if (
        (oldNavaid.cone != null && newNavaid.cone != null && oldNavaid.cone != newNavaid.cone) ||
        (oldNavaid.cone == null && newNavaid.cone != null) ||
        (oldNavaid.cone != null && newNavaid.cone == null)
    ) {
        return true;
    }

    if (
        (oldNavaid.arinc424fom != null && newNavaid.arinc424fom != null && oldNavaid.arinc424fom != newNavaid.arinc424fom) ||
        (oldNavaid.arinc424fom == null && newNavaid.arinc424fom != null) ||
        (oldNavaid.arinc424fom != null && newNavaid.arinc424fom == null)
    ) {
        return true;
    }

    return false;
}

function equalsMinScreenAngles(oldNavaid: NavaidModel, newNavaid: NavaidModel): boolean {
    const oldCollection = oldNavaid.actualScreeningAngle;
    const newCollection = newNavaid.actualScreeningAngle;

    // Check if collections have different sizes
    if (oldCollection.length != newCollection.length) {
        return false;
    }

    // Compare angles in both collections
    for (const oldAngle of oldCollection) {
        let matchFound = false;
        for (const newAngle of newCollection) {
            if (newAngle.id == null) {
                return false; // Invalid angle in the new collection
            }
            if (oldAngle.id == newAngle.id) {
                matchFound = true;
                if (!ScreeningAngle.equalsMinScreeningAngle(oldAngle, newAngle)) {
                    return false; // Mismatch in angle details
                }
                break; // No need to check further once a match is found
            }
        }
        if (!matchFound) {
            return false; // No match found for the current old angle
        }
    }

    return true;
}


function equalsSectorizations(oldNavaid: NavaidModel, newNavaid: NavaidModel): boolean {
    const oldCollection = oldNavaid.sectorizations;
    const newCollection = newNavaid.sectorizations;

    // Check if collections have different sizes
    if (oldCollection.length !== newCollection.length) {
        return false;
    }

    // Compare sectorizations in both collections
    for (const oldSector of oldCollection) {
        let matchFound = false;
        for (const newSector of newCollection) {
            if (newSector.id === null) {
                return false; // Invalid sectorization in the new collection
            }
            if (oldSector.id === newSector.id) {
                matchFound = true;
                if (!Sectorization.equalsSectorization(oldSector, newSector)) {
                    return false; // Mismatch in sectorization details
                }
                break; // No need to check further once a match is found
            }
        }
        if (!matchFound) {
            return false; // No match found for the current old sector
        }
    }

    return true;
}